export default "__VITE_ASSET__DRj2yMI8__"